// extracted by mini-css-extract-plugin
export default {"page":"CW-z","cartModal":"DW-z","checkout":"EW-z","placeholder":"FW-z","account":"GW-z"};